// extracted by mini-css-extract-plugin
export var link = "NavigationLink-module--link--ac4fc";
export var revealer = "NavigationLink-module--revealer--52d82";
export var text = "NavigationLink-module--text--d8931";